<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#ee0909"
  type="ball-atom"
  [fullScreen]="true"
>
  <p style="color: white">cargando ....</p>
</ngx-spinner>

<div class="container">
  <div class="row"></div>
  <div class="title-container">
    <b class="title">Listado de Entidades de Certificación y Evaluación</b>
  </div>
  <app-entidades-table-principal></app-entidades-table-principal>
</div>
